import React, { useState } from 'react'
import { CentralMonitoring } from '@/domain/models'
import { useAuth, useMediaQueries } from '@/presentation/hooks'
import { Box, Select } from '@/presentation/components'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { contactListHasError, monitoringListHasError, remotyFilterState, sectorListHasError, userListHasError } from '@/presentation/pages/Events/components'

type SelectRemotyEventCompanyProps = {
  disabled?: boolean
}

export const SelectRemotyEventCompany: React.FC<SelectRemotyEventCompanyProps> = ({ disabled }) => {
  const { getClient } = useAuth()
  const { isMobile } = useMediaQueries()

  const [isMenuOpen, setMenuOpen] = useState(false)
  const [currentCompany, setCompany] = useRecoilState(remotyFilterState)
  const setEventError = useSetRecoilState(monitoringListHasError)
  const setSectorError = useSetRecoilState(sectorListHasError)
  const setUserError = useSetRecoilState(userListHasError)
  const setContactError = useSetRecoilState(contactListHasError)

  const client = getClient()

  const companies = client?.centraisMonitoramento ?? []

  const handleSelectCompany = (company: CentralMonitoring): void => {
    setCompany({ remotyIdEquipamento: company.idEquipment, remotyNmEquip: company.nmEquipment })
    setMenuOpen(false)

    setEventError(false)
    setSectorError(false)
    setUserError(false)
    setContactError(false)
  }

  const getDescription = (): string => currentCompany.remotyNmEquip || 'Selecione o Equipamento'
  const handleOpen = (): void => {
    if (!disabled) {
      setMenuOpen(true)
    }
  }

  const customStyle = (): object => {
    if (isMobile) {
      return {
        margin: 'auto'
      }
    } else {
      return {
        marginLeft: 'auto'
      }
    }
  }

  return (
    <Box style={customStyle()}>
      <Select.Trigger
        label='Equipamento'
        description={getDescription()}
        disabled={disabled}
        onOpen={handleOpen}
      />
      <Select.Modal
        title='Selecione o equipamento'
        isOpen={isMenuOpen}
        onClose={() => setMenuOpen(false)}
        items={companies.map((company) => ({
          id: company.idEquipment,
          descricao: company.nmEquipment,
          data: company,
          isSelected: company.idEquipment === currentCompany.remotyIdEquipamento
        }))}
        onSelect={(_, company) => handleSelectCompany(company)}
      />
    </Box>
  )
}
